const CROSSHAIR_TICKS =
	"M12 19.5C12.5522 19.5001 13 19.9478 13 20.5V23C13 23.5522 12.5522 23.9999 12 24C11.4477 24 11 23.5523 11 23V20.5C11 19.9477 11.4477 19.5 12 19.5ZM12 6.5C15.0376 6.5 17.5 8.96243 17.5 12C17.5 15.0375 15.0375 17.5 12 17.5C8.96245 17.5 6.50003 15.0375 6.5 12C6.5 8.96243 8.96243 6.5 12 6.5ZM3.60742 11C4.11155 11.0513 4.50488 11.4774 4.50488 11.9951C4.50482 12.5127 4.11152 12.9389 3.60742 12.9902L3.50488 12.9951H1.00488C0.452639 12.9951 0.00494878 12.5473 0.00488281 11.9951C0.00488281 11.4428 0.452598 10.9951 1.00488 10.9951H3.50488L3.60742 11ZM23.1074 11C23.6115 11.0513 24.0049 11.4774 24.0049 11.9951C24.0048 12.5127 23.6115 12.9389 23.1074 12.9902L23.0049 12.9951H20.5049C19.9526 12.9951 19.5049 12.5473 19.5049 11.9951C19.5049 11.4428 19.9526 10.9951 20.5049 10.9951H23.0049L23.1074 11ZM12 0C12.5522 6.59659e-05 13 0.447756 13 1V3.5C13 4.05224 12.5522 4.49993 12 4.5C11.4477 4.5 11 4.05228 11 3.5V1C11 0.447715 11.4477 0 12 0Z"

const CROSSHAIR_RING =
	"M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"

const CROSSHAIR_RING_STROKE =
	"M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z"

export const CrosshairsIcon = ({ className }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		className={className}
		aria-hidden
	>
		<g fill="none">
			<path
				d={CROSSHAIR_TICKS}
				fill="url(#pl-cross-g0)"
				mask="url(#pl-cross-mask)"
			/>
			<path
				d={CROSSHAIR_TICKS}
				fill="url(#pl-cross-g0)"
				filter="url(#pl-cross-filter)"
				clipPath="url(#pl-cross-clip)"
			/>
			<path d={CROSSHAIR_RING} fill="url(#pl-cross-g1)" />
			<path d={CROSSHAIR_RING_STROKE} fill="url(#pl-cross-g2)" />
			<defs>
				<linearGradient
					id="pl-cross-g0"
					x1="12.005"
					y1="0"
					x2="12.005"
					y2="24"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#575757" />
					<stop offset="1" stopColor="#151515" />
				</linearGradient>
				<linearGradient
					id="pl-cross-g1"
					x1="12"
					y1="2"
					x2="12"
					y2="22"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#E3E3E5" stopOpacity=".6" />
					<stop offset="1" stopColor="#BBBBC0" stopOpacity=".6" />
				</linearGradient>
				<linearGradient
					id="pl-cross-g2"
					x1="12"
					y1="2"
					x2="12"
					y2="13.582"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#fff" />
					<stop offset="1" stopColor="#fff" stopOpacity="0" />
				</linearGradient>
				<filter
					id="pl-cross-filter"
					x="-100%"
					y="-100%"
					width="400%"
					height="400%"
					filterUnits="objectBoundingBox"
					primitiveUnits="userSpaceOnUse"
				>
					<feGaussianBlur
						stdDeviation="2"
						x="0%"
						y="0%"
						width="100%"
						height="100%"
						in="SourceGraphic"
						edgeMode="none"
						result="blur"
					/>
				</filter>
				<clipPath id="pl-cross-clip">
					<path d={CROSSHAIR_RING} fill="url(#pl-cross-g1)" />
				</clipPath>
				<mask id="pl-cross-mask">
					<rect width="100%" height="100%" fill="#FFF" />
					<path d={CROSSHAIR_RING} fill="#000" />
				</mask>
			</defs>
		</g>
	</svg>
)
